import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import {
  LayoutWrapperStyled as LayoutWrapper,
  ContentStyled as Content,
} from './styles/NotFoundStyled';

const duration = 0.3;
const AnimationVariants = {
  initial: {
    opacity: 0,
    y: 15,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration,
      delay: duration,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    y: -15,
    transition: {
      duration,
    },
  },
};

const NotFoundLayout = ({ children }) => {
  return (
    <LayoutWrapper>
      <AnimatePresence>
        <Content
          as={motion.div}
          variants={AnimationVariants}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          {children}
        </Content>
      </AnimatePresence>
    </LayoutWrapper>
  );
};

NotFoundLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NotFoundLayout;
